import Vue from 'vue'
import VueRouter from 'vue-router'
import VuePageTitle from 'vue-page-title'

Vue.use(VuePageTitle, {
  suffix: ' | Akari Takada'
})

Vue.use(VueRouter)
  
export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/portfolio',
      name: 'Design',
      component: () => import('@/views/Design.vue')
    },
    // {
    //   path: '/cv',
    //   name: 'CV',
    //   component: () => import('@/views/comingSoon.vue')
    // },
    {
      path: '/comingsoon',
      name: 'comingSoon',
      component: () => import('@/views/comingSoon.vue')
    },
    {
      path: '/designProjects/love',
      name: 'Love',
      component: () => import('@/views/designProjects/Love.vue')
    },
    {
      path: '/designProjects/trufoo',
      name: 'Trufoo',
      component: () => import('@/views/designProjects/Trufoo.vue')
    },
    {
      path: '/designProjects/sodastream',
      name: 'Sodastream',
      component: () => import('@/views/designProjects/Sodastream.vue')
    },
    {
      path: '/designProjects/sleepbox',
      name: 'Sleepbox',
      component: () => import('@/views/designProjects/Sleepbox.vue')
    },
    {
      path: '/designProjects/evo',
      name: 'Evo',
      component: () => import('@/views/designProjects/Evo.vue')
    },
    {
      path: '/designProjects/mindpod',
      name: 'Mindpod',
      component: () => import('@/views/designProjects/Mindpod.vue')
    },
    {
      path: '/designProjects/thesis',
      name: 'Thesis',
      component: () => import('@/views/designProjects/Thesis.vue')
    }
  ]
})
